import React, { useEffect, useState } from 'react';
import saleItems from '../assets/saleItems';
import Navigation from '../components/Navigation';
import { useParams } from 'react-router-dom';
import Footer from '../components/Footer';
import RentSaleProperty from '../components/RentSaleComponents/RentSaleProperty';
import MortgageCalculator from '../components/MortgageCalculator';
import { Box } from '@mui/material';

function SaleProject() {

  const {id} = useParams();
  const [saleProject, setSaleProject] = useState(null);

  useEffect(() => {

    let saleProject = saleItems.find(saleProject => saleProject.id === parseInt(id));

    if (saleProject) {
      setSaleProject(saleProject);
    }

  }, [id])

  return (
    <div className="App">
      <Box>
        <Navigation />
        {
          saleProject ? (
            <Box>
              <RentSaleProperty propertyAddress={saleProject.address} propertyImage={saleProject.image1} propertyImages={saleProject.images} propertyPrice={saleProject.price} propertyLongDescription={saleProject.longDescription} propertyBedrooms={saleProject.bedrooms} propertyBathrooms={saleProject.bathrooms} propertyLivingrooms={saleProject.livingrooms} />

              <MortgageCalculator fullPropertyPrice={saleProject.price} />
            </Box>
          ) : (
            null
          )
        }
        <Footer />
      </Box>
    </div>
  )
}

export default SaleProject;
